<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <div class="box-body">
            <div class="row">
              <div class="col-sm-6 text-left">
                <div class="form-group text-left">
                  <router-link to="/printerTable">
                    <div class="btn btn-default btn-table-title">返回出單機列表</div>
                  </router-link>
                  <router-link :to="{path: '/crPrinterStore/' + $route.params.printer_id}">
                    <div class="btn btn-default btn-table-title">新增門市綁定</div>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div>
                  <div class="input-group">
                    <span class="input-group-addon">
                      名稱 (ID)
                    </span>
                    <div class="form-control form-info">
                      出單機{{printerInfo.printer_id}}號 ({{printerInfo.printer_id}})
                    </div>
                  </div>
                  <br />
                </div>
                <div>
                  <div class="input-group">
                    <span class="input-group-addon">
                      類型
                    </span>
                    <div class="form-control form-info">
                      {{printerInfo.printer_type}}
                    </div>
                  </div>
                  <br />
                </div>
                <div>
                  <div class="input-group">
                    <span class="input-group-addon">
                      辨識碼
                    </span>
                    <div class="form-control form-info">
                      {{printerInfo.printer_identity}}
                    </div>
                  </div>
                  <br />
                </div>
                <div>
                  <div class="input-group">
                    <span class="input-group-addon">
                      啟用
                    </span>
                    <div class="form-control form-info">
                      <span v-if="printerInfo.printer_is_enabled" class="label label-success">啟用</span>
                      <span v-if="!printerInfo.printer_is_enabled"  class="label label-danger">未啟用</span>
                    </div>
                  </div>
                  <br />
                </div>
              </div>
              <div class="col-xs-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">綁定店名 (ID)</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">綁定名稱 (ID)</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">啟用</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="even" role="row" v-for="(store, index) in storeList">
                    <!-- cloumn 0 -->
                    <td class="sorting_1">{{index + 1}}</td>
                    <td>
                      <router-link :to="'/printerStore/' + $route.params.printer_id + '/' + store.store_id">{{store.store_name}} ({{store.store_id}})</router-link>
                    </td>
                    <td>{{store.binding_name}} ({{store.binding_id}})</td>
                    <td>
                      <span v-if="store.binding_is_enabled" class="label label-success">啟用</span>
                      <span v-if="!store.binding_is_enabled"  class="label label-danger">未啟用</span>
                    </td>
                    <td>
                      <router-link :to="'/upPrinterStore/' + $route.params.printer_id + '/' + store.binding_id"><button class="btn btn-default"><i class="fa fa-pencil"></i></button></router-link>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import mqttTable from './Temp/MqttTableTemp.vue'
export default {
  name: 'Tables',
  data () {
    return {
      printerInfo: {},
      storeList: []
    }
  },
  mounted () {
  },
  components: {
    'mqtt-table': mqttTable
  },
  methods: {
    printerType (type) {
      switch (type) {
        case 1: return '熒埔'
        case 2: return '飛鵝'
      }
    },
    getPrinterInfo () {
      var self = this
      var url = '/printer/' + this.$route.params.printer_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.printerInfo = response.data.printer
          self.storeList = self.printerInfo.store_list
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  created () {
    this.fixedH()
    this.getPrinterInfo()
  }
}
</script>



// WEBPACK FOOTER //
// PrinterInfo.vue?0b1a2c9c